export const handleUndefined = (item) => {
  if (item) return item;
  else return "-";
};
